import { useState, useEffect } from 'react';
import {
    FormControl, Card, CardContent, Table, Grid, TextField, Button, TableBody, TableCell, Container, TableContainer, TablePagination, Modal, Box, TableRow, Typography, Divider
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import Page from './../../components/Page';
import Scrollbar from './../../components/Scrollbar';
import { UserListHead } from '../../sections/@dashboard/user';
import HeaderBreadcrumbs from './../../components/HeaderBreadcrumbs';
import { BorderColorOutlined } from "@mui/icons-material";
import "./PlayerManager.css"
import { toast } from 'react-toastify';
import Loader from 'src/components/Loader';
import { GetPlayerManagerList, ResetGetPlayerManagerList, ResetUpdatePlayerManager, UpdatePlayerManager } from 'src/redux/actions/PlayerManagerAction';

export default function PlayerFootballManager() {
    const dispatch = useDispatch();
    const playerManagerData = useSelector(state => state.player_manager.player_manager_list.data)
    const loadingSelector = useSelector(state => state.player_manager.loading)
    const updateSelector = useSelector(state => state.player_manager.player_manager_edit)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [showeditModal, setShoweditModal] = useState(false)
    const [uploadedImage, setUploadedImage] = useState(null)
    const [playerJerseyNumber, setPlayerJerseyNumber] = useState()
    const [teamModalData, setTeamModalData] = useState()
    const [playerNameString, setPlayerNameString] = useState("")

    useEffect(() => {
        dispatch(GetPlayerManagerList({ type: "Football" }, (page + 1), rowsPerPage))

        return () => dispatch(ResetGetPlayerManagerList())
    }, [dispatch, page, rowsPerPage])

    const handleResetFilter = () => {
        setPlayerNameString("")
        dispatch(GetPlayerManagerList({ type: "Football" }, (page + 1), rowsPerPage))
    }

    useEffect(() => {
        if (Object.keys(updateSelector).length > 0) {
            if (updateSelector.status) {
                toast.success("Updated Successfully!", { theme: "colored" })
                setShoweditModal(false)
                setPlayerNameString("")
                dispatch(GetPlayerManagerList({ type: "Football" }, (page + 1), rowsPerPage))
                dispatch(ResetUpdatePlayerManager())
            }
        }
    }, [updateSelector])

    const handleEditCloseModal = () => {
        setShoweditModal(false)
        setTeamModalData("")
    }

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleEdit = (data) => {
        setShoweditModal(true)
        setTeamModalData(data)
    }

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "30%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const handleChange = (e) => {
        const { files } = e.target
        if (files?.length > 0) {
            const { name, type } = files[0];
            const params = {
                key: name.includes('.') ? name.substring(0, name.indexOf('.')) : name,
                extension: type.includes('/') ? type.substring(type.indexOf('/') + 1) : type
            };

            if (
                params.extension.toLowerCase() === "jpg" ||
                params.extension.toLowerCase() === "jpeg" ||
                params.extension.toLowerCase() === "png"
            ) {
                if (files) {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        document.getElementById('profileImg').src = e.target.result;
                    };
                    reader.readAsDataURL(e.target.files[0]);
                    setUploadedImage(e.target.files[0])
                }
                toast.success('Image Uploaded Successfully', { theme: "colored" });
            } else {
                toast.error("Only image with .jpeg, .jpg, .png extentions are valid.");
            }
        }
    }

    const handleEditSubmit = (e) => {
        e.preventDefault();
        let formData = new FormData();
        formData.append("pid", teamModalData.player_id);
        formData.append("type", "Football");
        if (playerJerseyNumber) {
            formData.append("jersy_no", playerJerseyNumber);
        }
        if (uploadedImage) {
            formData.append("logo_url", uploadedImage);
        }
        dispatch(UpdatePlayerManager(formData))
    }

    const handleNameFilter = (value) => {
        setPlayerNameString(value)
        if (value.length > 3) {
            dispatch(GetPlayerManagerList({ type: "Football", player_name: value }, (page + 1), rowsPerPage))
        } else if (value.length == 0) {
            dispatch(GetPlayerManagerList({ type: "Football" }, (page + 1), rowsPerPage))
        }
    }

    return (
        <Page title="Football Player Manager">
            {loadingSelector ? <Loader /> : null}

            <Modal
                open={showeditModal}
                onClose={handleEditCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Edit
                    </Typography>
                    <Divider />
                    <br />
                    <form autoComplete="off" onSubmit={handleEditSubmit}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    required
                                    type="number"
                                    defaultValue={teamModalData?.jersy_no}
                                    onChange={(e) => setPlayerJerseyNumber(e.target.value)}
                                    style={{ marginTop: 30, width: "100%" }}
                                    label="Player Jersey Number"
                                    variant="outlined"
                                    inputProps={{ maxLength: 10 }}
                                />
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 30, marginBottom: 20 }}>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => handleChange(e)}
                                    style={{ width: "100%", fontSize: 16 }}
                                />
                                {uploadedImage ?
                                    <img src="" id="profileImg" className="img-fluid" height="70" style={{ marginTop: 10 }} alt="" />
                                    : null
                                }

                                {teamModalData && !uploadedImage ?
                                    <img src={teamModalData.player_image} className="img-fluid" height="70" style={{ marginTop: 10 }} alt="" />
                                    : null
                                }
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    align={"center"}
                                    style={{ marginTop: 20, width: "100%" }}
                                    variant="contained"
                                    fullWidth
                                    size="large"
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </form>
                </Box>
            </Modal>

            <Container maxWidth="lg">
                <HeaderBreadcrumbs
                    heading="Player Manager"
                    links={[
                        { name: 'Dashboard', href: "/dashboard/app" },
                        { name: 'Player Manager' }
                    ]}
                />

                <Card>
                    <CardContent>
                        <Scrollbar>
                            <TableContainer sx={{ minWidth: 800 }}>
                                <Grid container spacing={2} style={{ marginBottom: 10, marginTop: 2 }}>
                                    <Grid item md={3}>
                                        <FormControl fullWidth>
                                            <TextField
                                                onChange={({ target }) => handleNameFilter(target.value)}
                                                type="text"
                                                label="Player Name"
                                                variant="outlined"
                                                value={playerNameString}
                                            />
                                        </FormControl>
                                    </Grid>
                                    <Grid item md={9} style={{ textAlign: "right", marginTop: 15, paddingRight: 15 }}>
                                        {playerNameString &&
                                            <div className='reset-filter'>
                                                <Button
                                                    size="small"
                                                    color="primary"
                                                    className='btn'
                                                    onClick={handleResetFilter}
                                                >
                                                    Reset Filter
                                                </Button>
                                            </div>
                                        }
                                    </Grid>
                                </Grid>

                                <Table>
                                    <UserListHead
                                        rowCount={playerManagerData && playerManagerData?.data?.total_count}
                                        headLabel={[
                                            { id: "c_no", label: "Sr no.", alignRight: false },
                                            { id: 'image', label: 'Image', alignRight: false },
                                            { id: 'name', label: 'Player Name', alignRight: false },
                                            { id: 'jersey_number', label: 'Jersey number', alignRight: false },
                                            { id: 'rating', label: 'Rating', alignRight: false },
                                            { id: 'action', label: 'Action', alignRight: true }
                                        ]}
                                    // onRequestSort={handleRequestSort}
                                    />
                                    <TableBody>
                                        {playerManagerData && playerManagerData.data.player_list.map((value, index) => {
                                            return (
                                                <TableRow hover key={index}>
                                                    <TableCell component="th" scope="row">
                                                        {page * rowsPerPage + (index + 1)}.
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        <div className='small-flag'>
                                                            {value?.player_image &&
                                                                <img src={value?.player_image} alt={value?.player_name} className="img-fluid" />
                                                            }
                                                        </div>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">{value?.player_name ? value?.player_name : "-"} </TableCell>
                                                    <TableCell> {value?.jersy_no ? value?.jersy_no : "-"} </TableCell>
                                                    <TableCell> {value?.rating ? value?.rating : "-"} </TableCell>
                                                    <TableCell component="th" scope="row" align='right'>
                                                        <Button
                                                            size="small"
                                                            color="primary"
                                                            onClick={() => handleEdit(value)}
                                                        >
                                                            <BorderColorOutlined />
                                                        </Button>
                                                    </TableCell>
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Scrollbar>

                        <TablePagination
                            rowsPerPageOptions={[25, 50, 100, 150, 200]}
                            component="div"
                            count={playerManagerData && playerManagerData.data?.total_count}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
}
